// Artist reflection tags — one-tap mood/grade indicators the artist applies
// to an order during/after drawing. Surfaces in ArtistQueueView (active
// shift) and ShiftManager (post-shift recap). Customer-facing on keepsake
// pages and in the Pancakeopedia. The 🧪 Lab emoji is a customer-facing
// reflection tag, not a dev affordance.

export const ARTIST_TAGS = [
  { id: "fire",  emoji: "🔥", label: "Fire" },
  { id: "clean", emoji: "🎯", label: "Clean" },
  { id: "magic", emoji: "✨", label: "Magic" },
  { id: "lab",   emoji: "🧪", label: "Lab" },
  { id: "grind", emoji: "💪", label: "Grind" },
  { id: "rough", emoji: "🫠", label: "Rough" },
  { id: "cute",  emoji: "🥰", label: "Cute" },
  { id: "funny", emoji: "😂", label: "Funny" },
];
